<label class="field-label" *ngIf="rotulo" [attr.for]="id">{{ rotulo }}</label>

<div class="campo-data">
  <nb-form-field>
    <input
      nbInput
      fullWidth
      type="text"
      [id]="id"
      [name]="id"
      inputmode="numeric"
      autocomplete="bday"
      mask="00/00/0000"
      [placeholder]="placeholder"
      [disabled]="desabilitado"
      [readonly]="somenteLeitura"
      [(ngModel)]="texto"
      (ngModelChange)="aoDigitar($event)"
    />

    <button
      nbSuffix
      nbButton
      ghost
      type="button"
      class="btn-calendario"
      [disabled]="desabilitado || somenteLeitura"
      (click)="abrirCalendario()"
      title="Escolher no calendário"
      aria-label="Escolher a data no calendário"
    >
      <nb-icon pack="eva" icon="calendar-outline"></nb-icon>
    </button>
  </nb-form-field>

  <!-- Seletor do aparelho. Fica fora do fluxo: quem digita não esbarra nele, e o botão acima
       é quem o abre. -->
  <input
    #nativo
    class="campo-data-nativo"
    type="date"
    tabindex="-1"
    aria-hidden="true"
    [value]="valorIso"
    (change)="aoEscolherNoCalendario($any($event.target).value)"
  />
</div>

<small class="campo-data-ajuda" *ngIf="ajuda">{{ ajuda }}</small>
